import React, {useEffect, useState} from 'react';
import {BackdropProps} from '../tooltip_types.web';
import {backDropStyles} from '../tooltip_styles.web';

export const ANIMATION_DURATION = 250;

export default function Backdrop({
  children,
  onClick,
  visible,
  style,
}: BackdropProps) {
  const [delayedVisible, setDelayedVisible] = useState(visible);

  useEffect(() => {
    if (visible) {
      setDelayedVisible(true);
    } else {
      const timeout = setTimeout(
        () => setDelayedVisible(false),
        ANIMATION_DURATION,
      );
      return () => clearTimeout(timeout);
    }
  }, [visible]);

  if (!delayedVisible) return null;

  window.addEventListener('click', function (e) {
    //@ts-ignore
    if (document.getElementById('tooltipElement')?.contains(e.target)) {
      alert('Clicked in Box');
      EventTarget;
    } else {
    }
  });

  return (
    <div
      id={'tooltipElement'}
      style={{...backDropStyles.modalContent, ...style}}
      onClick={e => (e.stopPropagation(), onClick())}>
      {children}
    </div>
  );
}
